<div class="pna-flow"></div>
<footer class="footer">
  <div class="footer-content">
    <div>Last Update: <span>July - 2025</span></div>
    <div class="sep" id="spaced">|</div>
    <div class="spaced">
      Content Contact:
      <a
        href="https://chevron.sharepoint.com/sites/ASBUTH-SCM/SitePages/OP/OP.aspx"
        target="_blank"
        >Thailand SCM Team</a
      >
    </div>
    <div class="sep" id="spaced">|</div>
    <div class="spaced"><span>Company Confidential</span></div>
  </div>
  <hr />
  <div class="footer-content">
    <div><span>©2011 Chevron Corporation</span></div>
    <div class="sep" id="spaced">|</div>
    <div class="spaced">
      Technical Contact:
      <a
        id="Footer_hplTechnicalContact"
        href="https://chevron.sharepoint.com/sites/ASBUTH-SCM/SitePages/OP/OP.aspx "
        target="_blank"
        >Thailand SCM Team</a
      >
    </div>
    <div class="sep" id="spaced">|</div>
    <div class="spaced">
      OPCO:
      <a
        id="Footer_hplOpco"
        href="https://chevron.sharepoint.com/sites/ASBUTH"
        target="_blank"
        >Chevron Thailand</a
      >
    </div>
  </div>
</footer>
